/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');

// Optional Vendor Requires
// require('./vendor/imagesloaded.pkgd.min.js');
// require('./vendor/jquery.actual.min');
// require('./vendor/jquery.validate.min');
// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
// require('./vendor/slick-slider');
// require('./vendor/youtube-iframe-assistant');
// require('./vendor/picturefill');
// require('./vendor/waypoint');
// require('./vendor/waypoint-animate');

// Sliders
//require('./app/sliders/slider-feature');


// ScrollTrigger
//require('./app/scrollTrigger');

// App Requires
// require('./app/config');
// require('./app/helpers');
require('./app/primary-navigation');
require('./app/page-navigation');
//require('./app/equal-height');
//require('./app/smooth-scroll');
require('./app/sliders');
require('./app/video-player');

if ($(window).outerWidth() < 1025) {
	$('.contact-toggle').addClass('collapsed').attr('aria-expanded', false);
	$('.contact-collapse').removeClass('show');
}
